import { useEffect, useRef } from "react";

export default function usePolling(
  callback,
  {
    interval = 15000,
    enabled = true,
    immediate = false,
    pauseRef = null,
  } = {}
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return;

    if (immediate && !pauseRef?.current) {
      callbackRef.current();
    }

    const id = setInterval(() => {
      if (pauseRef?.current) return;

      callbackRef.current();
    }, interval);

    return () => clearInterval(id);
  }, [interval, enabled, immediate, pauseRef]);
}